export default {
  getOfflineAssessments: {
    url: "/api/v2/offline-assessment/",
    method: "get",
  },
  createOfflineAssessment: {
    url: "/api/v2/offline-assessment/",
    method: "post",
  },
  getOfflineAssessmentById: {
    url: "/api/v2/offline-assessment/{assessment_id}",
    method: "get",
  },
  updateOfflineAssessmentById: {
    url: "/api/v2/offline-assessment/{assessment_id}/school/{school_id}",
    method: "put",
  },
  deleteOfflineAssessmentById: {
    url: "/api/v2/offline-assessment/{assessment_id}/school/{school_id}",
    method: "delete",
  },
  getAcademicYears: {
    url: "/api/v2/academic-years/",
    method: "get",
  },
  getOfflineAssessmentSections: {
    url: "/api/v2/offline-assessment-sections/",
    method: "get",
  },
  getOfflineAssessmentSectionById: {
    url: "/api/v2/offline-assessment-sections/{id}",
    method: "get",
  },
  getOfflineAssessmentParameters: {
    url: "/api/v2/offline-assessment/parameters",
    method: "get",
  },
  updateOfflineAssessmentSectionMarks: {
    url: "/api/v2/offline-assessment-sections/{id}/marks",
    method: "put",
  },
  generateOfflineAssessmentReport: {
    url: "/api/v2/offline-assessment-sections/{id}/generate-report",
    method: "put",
  },
  downloadOfflineAssessmentSectionExcel: {
    url: "/api/v2/offline-assessment-sections/{id}/excel",
    method: "get",
  },
  downloadOfflineAssessmentSectionReport: {
    url: "/api/v2/offline-assessment-sections/{id}/download-report",
    method: "get",
  },
  getSchoolList: {
    url: "/api/v2/school/lists",
    method: "get",
  },
  getAllSchoolListForCoordinator: {
    url: "/api/v2/school/school_coordinator/school_details",
    method: "get",
  },
  getClassBySchool: {
    url: "/api/v2/class/school/{school_id}",
    method: "get",
  },
};
